import { render, staticRenderFns } from "./OptionInput.vue?vue&type=template&id=6a86623c&scoped=true"
import script from "./OptionInput.vue?vue&type=script&lang=js"
export * from "./OptionInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a86623c",
  null
  
)

export default component.exports